import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  container: {
    maxWidth: "x1ptgtm5",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingTop: "xf6mfmo",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x117aka2",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    textAlign: "x2b8uid",
    $$css: true
  },
  title: {
    marginTop: "xwg69jb",
    marginBottom: "xhbfen4",
    fontSize: "xngnso2",
    $$css: true
  },
  lead: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    lineHeight: "x1evy7pa",
    $$css: true
  },
  code: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    marginTop: "x178dpqu",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    backgroundColor: "x15xno7f",
    color: "x1gonuu0",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "x1qh5nd4",
    fontSize: "x1q74xe4",
    fontWeight: "x1sl8krj",
    letterSpacing: "xribhvm",
    cursor: "x1ypdohk",
    $$css: true
  },
  codeIcon: {
    flexShrink: "x2lah0s",
    $$css: true
  },
  hint: {
    marginTop: "xhj8ucd",
    marginBottom: "x1t84w78",
    fontSize: "x1dcheo9",
    $$css: true
  }
};